export default function isInIframe() {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
}

// TODO: move handleIFrame and handleIFrames from ./utils.js to this file



// WEBPACK FOOTER //
// ./src/utils/iframe.js